// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dhelmise: PokeData = {
  "id": 781,
  "name": "dhelmise",
  "height": 39,
  "weight": 2100,
  "base_experience": 181,
  "types": [
    PokeType.GHOST,
    PokeType.GRASS
  ],
  "api_moves": [
    "slam",
    "wrap",
    "absorb",
    "mega-drain",
    "growth",
    "giga-drain",
    "rapid-spin",
    "shadow-ball",
    "whirlpool",
    "astonish",
    "metal-sound",
    "gyro-ball",
    "energy-ball",
    "switcheroo",
    "power-whip",
    "heavy-slam",
    "phantom-force",
    "anchor-shot"
  ],
  "moves": [
    "shadow-ball",
    "whirlpool",
    "metal-sound",
    "energy-ball",
    "power-whip",
    "phantom-force",
    "poltergeist",
    "spectral-chain",
    "synthesis",
    "lick",
    "solar-beam",
    "bullet-seed",
    "soul-sacrifice"
  ],
  "evolution_chain": {
    "id": 407,
    "item": null,
    "species": [
      {
        "name": "dhelmise",
        "order": 781,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 63,
    "ability_power": 207
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
